export const overviewContainerStyles = {
  flexFlow: 'column',
  borderRadius: '20px',
  pl: '75px',
  pr: '75px',
  pt: '50px',
  pb: '50px',
  backgroundColor: 'white',
};

export const overviewSectionContainerStyles = {
  borderBottom: '1px solid',
  borderColor: '#DCDCDC',
  pb: '25px',
  mb: '25px',
  '&:last-child': {
    borderBottom: 'none',
    mb: '0',
    pb: '0',
  },
};

export const overviewSectionTitleContainerStyles = {
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: '30px',
};

export const overviewSectionTitleStyles = {
  fontSize: '20px',
  fontWeight: 500,
  mr: '25px',
};

export const overviewEditButtonStyles = {
  height: '25px',
  fontWeight: 400,
  pl: '5px',
  pr: '10px',
  borderRadius: '20px',
  borderColor: '#DCDCDC',
  color: 'alea.500',
};

export const overviewItemBoxStyles = {
  minWidth: '200px',
  maxWidth: '200px',
  flexBasis: '200px',
  mb: '15px',
};

export const overviewItemTitleStyles = {
  fontSize: '15px',
  fontWeight: 300,
  color: 'alea.500',
};

export const overviewItemValueStyles = {
  fontSize: '18px',
  fontWeight: '400',
  color: '#000000',
};

export const overviewLivingAreasItemStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  px: '15px',
  h: '48px',
  borderRadius: '20px',
  border: '1px solid',
  borderColor: '#C6C6C6',
  mr: '12px',
  color: 'black',
};

export const overviewDayNightItemStyles = {
  width: '100px',
  height: '40px',
  border: '1px solid',
  borderColor: '#C6C6C6',
  borderRadius: '20px',
  textAlign: 'center',
  h: '50px',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '18px',
};
